import Auth from "../util/auth";

const initialAuth = {
    token: localStorage.getItem('so_token') || 'a.b.c',
    status: false
};

export default (state = {...initialAuth}, action) => {
    switch (action.type) {
        case 'UPDATE_AUTH_TOKEN':
            return {
                token: action.payload,
                status: !Auth.getInstance().update(action.payload)
            };

        case 'UPDATE_AUTH_STATUS':
            return {
                ...state,
                status: action.payload
            };

        case 'LOGIN':
            return {
                ...state,
                token: action.payload.token,
                status: true
            };

        case 'LOGOUT':
            return {
                token: '..',
                status: false
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/auth.js